module.exports = __webpack_public_path__ + "img/stas-main_768.571f219e.jpg";